// Miroir de la ligne DataTableFieldParameterDefinition (Id + TechnicalName), telle que le back
// l'imbrique désormais dans FilterParameterVariableDto.
class DataTableFieldParameterDefinitionDto {
    Id: number;
    TechnicalName: string;

    constructor(id: number, technicalName: string) {
        this.Id = id;
        this.TechnicalName = technicalName;
    }
}

export default DataTableFieldParameterDefinitionDto;
